import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "guest-search" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = {
  key: 1,
  class: "error-banner"
}
const _hoisted_7 = { class: "error-message" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_11 = { class: "error-message" }
const _hoisted_12 = {
  key: 1,
  class: "error-banner"
}
const _hoisted_13 = { class: "error-message" }
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "category",
  style: {"font-weight":"bold"}
}, " Category:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { style: {"font-style":"italic","margin":"0","text-align":"left","color":"grey"} }, " Note: if no category is entered or if the entered category is invalid, cafes will be displayed. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { id: _ctx.autocompleteContainer1Id }, null, 8, _hoisted_3),
      (_ctx.address1Missing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.address1Missing), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.invalidAddress1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.invalidAddress1), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", { id: _ctx.autocompleteContainer2Id }, null, 8, _hoisted_9),
      (_ctx.address2Missing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.address2Missing), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.invalidAddress2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.invalidAddress2), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createElementVNode("input", {
        type: " text",
        id: "category",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category) = $event)),
        placeholder: "e.g., cafe, restaurant"
      }, null, 512), [
        [_vModelText, _ctx.category]
      ]),
      _hoisted_16
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
    }, "Let's Go")
  ]))
}